/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Space_Files_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "A file has to be embedded before the knowledge base can search it. Enable auto-embed, or embed the file from the toolbar, then @-mention the space or file in..." |
*
* @param {Uno_Edu_Space_Files_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_space_files_chip2_answer = /** @type {((inputs?: Uno_Edu_Space_Files_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Space_Files_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Datei muss eingebettet sein, bevor die Wissensbasis sie durchsuchen kann. Aktivieren Sie die automatische Einbettung oder betten Sie die Datei über die Symbolleiste ein und erwähnen Sie dann den Space oder die Datei mit @ in Ihrem Chat.")
	return /** @type {LocalizedString} */ ("A file has to be embedded before the knowledge base can search it. Enable auto-embed, or embed the file from the toolbar, then @-mention the space or file in your chat.")
});